<div class="wrapper" *ngIf="router.url !== '/style-guide'; else styleGuideSection">
  @if (!isHeaderHidden()) {
    <app-header></app-header>
  }

  <div class="d-flex flex-row flex-grow-1">

    @if (!isSidebarHidden()) {
      <div [ngClass]="isCollapsed ? 'sidebar-wrapper collapsed' : 'sidebar-wrapper expanded'">
        <app-sidebar
          [isCollapsed]="isCollapsed"
          (collapsedChange)="toggleSidebar($event)"
        ></app-sidebar>
      </div>
    }

    <div class="d-flex flex-column flex-grow-1" style="min-width: 0;">
      <main class="bg-body-tertiary flex-grow-1 py-3">
        <div class="main-content-inner" [class.full-width]="isFullWidthPage()">
          <router-outlet></router-outlet>
        </div>
      </main>

      <app-footer class="px-0"></app-footer>
    </div>
  </div>
</div>

<ng-template #styleGuideSection>
  <router-outlet></router-outlet>
</ng-template>

<app-spinner></app-spinner>

<!-- AI Assistant Toggle Button -->
<button
  *ngIf="activeMode === 'provider' && !isAiAssistantOpen"
  class="btn btn-warning position-fixed bottom-0 end-0 m-4 shadow-lg d-flex align-items-center justify-content-center gap-2"
  style="z-index: 9998; border-radius: 50px; padding: 10px 20px; font-weight: 600; color: white;"
  (click)="toggleAiAssistant()">
  <i class="bi bi-person-circle fs-5"></i>
  Talk to Miles
</button>

<!-- AI Assistant Modal (Angular controls visibility) -->
<ai-chat
  *ngIf="activeMode === 'provider' && isAiAssistantOpen"
  [authData]="currentUser"
  layout="modal"
  [apiEndpoint]="aiApiEndpoint"
  [suggestEndpoint]="aiSuggestEndpoint"
  [providerId]="currentUser?.provider_id"
  (logout)="handleLogout()"
  (close)="isAiAssistantOpen = false"
  (quoteListing)="onQuoteListing($event.detail)">
</ai-chat>
